import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import React, { Suspense, lazy } from 'react';
import retry from '../utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "emote_selector" */ './redux/ModuleLoadable')));
const LoadableSelector = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "emote_selector" */ './EmoteSelectorNg')));
const EmoteSelectorNgLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "EmoteSelectorNgLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama'
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableSelector, props)));
};
EmoteSelectorNgLoadable.displayName = 'EmoteSelectorNgLoadable';
export default EmoteSelectorNgLoadable;

//# sourceMappingURL=EmoteSelectorNgLoadable.js.map